import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { UserType } from '../models/user';
import paths from '../routing/paths';
import useUser from '../state/useUser';
import AdminNav from '../components/smart/AdminNav';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const ProtectedScreens = ({ admin }: { admin?: boolean }) => {
  const [user] = useUser();
  const location = useLocation();

  if (!user.id) {
    const redirect =
      location.pathname === paths.profile
        ? ''
        : `?returnUrl=${location.pathname}${location.search ? `?${location.search}` : ''}`;
    return <Navigate to={`${paths.login}${redirect}`} replace />;
  }

  if (admin && user.userType !== UserType.Admin) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <Typography variant="h6">Unauthorized</Typography>
      </Box>
    );
  }

  if (admin) {
    return (
      <AdminNav>
        <Outlet />
      </AdminNav>
    );
  }

  return <Outlet />;
};

export default ProtectedScreens;
